/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-escape */
import { useEffect, useState } from 'react'
import { Form, Spin, notification } from 'antd'
import { useNavigate } from 'react-router-dom'

import { handleAsyncRequest } from 'utils/helper'
import useAppSelector from 'hooks/useAppSelector'
import guildApi from 'apis/guildApi'
import links from 'apps/links'

export interface dataProps {
  horses_in_guild: string | number
  total_race: string | number
}

import JoinRequirementStyled from './styled'
import { InputCustomV2 } from 'shared'
import Button from 'shared/Button'
import { useTranslation } from 'react-i18next'
import { GUILD_MESSAGE } from 'i18n/constants'
import { MAX_ID } from 'apps/constants'

const regix = /^[0-9]+$/

type FormField = {
  horsesInGuild?: number
  totalRacesJoined?: number
}

const JoinRequirement = () => {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [api, contextHolder] = notification.useNotification()
  const { t } = useTranslation()
  const [loading, setLoading] = useState<boolean>(true)
  const { profile } = useAppSelector(state => state)
  const [loadingUpdate, setLoadingUpdate] = useState<boolean>(false)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [isShowAction, setIsShowAction] = useState(false)

  useEffect(() => {
    if (profile?.role_in_guild === 'MASTER') {
      setIsShowAction(true)
    }
  }, [profile])

  useEffect(() => {
    profile?.guild_id && getManagerData()
  }, [profile])

  const getManagerData = async () => {
    const [error, result]: any = await handleAsyncRequest(guildApi.getRaceParticipationGuild(profile?.guild_id))

    if (error) {
      navigate(links.guild.joinGuild())
    }

    if (result) {
      const guildData = result?.data
      form.setFieldsValue({
        horsesInGuild: guildData?.horses_in_guild ?? 0,
        totalRacesJoined: guildData?.total_race ?? 0,
      })
    }
    setLoading(false)
  }

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: 4
    })

    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === 'ERROR' ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const handleConfirmEdit = async (value: any) => {
    setLoadingUpdate(true)
    const { horsesInGuild, totalRacesJoined } = value

    const payload: dataProps = {
      horses_in_guild: +horsesInGuild,
      total_race: +totalRacesJoined
    }
    const [error, result]: any = await handleAsyncRequest(
      guildApi.postRaceParticipationGuild(profile?.guild_id, payload)
    )
    setLoadingUpdate(false)

    if (error) {
      openNotification('ERROR', error.message || error.errors[0]?.message)
    }

    if (result) {
      openNotification('SUCCESS', 'Edit Join Requirements successfully!')
      getManagerData()
      _handleEdit()
    }
  }

  const _handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const isCtrlV = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v'
    if (isCtrlV) {
      return // cho phép paste
    }

    if (['e', 'E', '+', '-', '.', ','].includes(e.key) || [38, 40].includes(e.keyCode)) {
      e.preventDefault()
      return
    }

    if (e.key === 'Unidentified') {
      return
    }

    if (!regix.test(e.key) && e.keyCode !== 8) {
      e.preventDefault()
    }
  }

  const _handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData('text')
    if (!regix.test(pasted)) {
      e.preventDefault()
    }
  }

  const _handleEdit = () => {
    setIsEdit(!isEdit)
  }

  const handleChangeHorse = (value: any, fieldName: string) => {
    let result = 0
    if (!value) {
      result = 0
    } else if (+value > MAX_ID) {
      result = MAX_ID
    } else {
      result = +value
    }
    form.setFieldValue(fieldName, result)
  }

  return (
    <JoinRequirementStyled>
      {contextHolder}
      {loading ? (
        <div className='loading'>
          <Spin className='mt-2 mr-3' />
        </div>
      ) : (
        <>
          <Form form={form} name='basic' onFinish={handleConfirmEdit} autoComplete='off'>
            {values => {
              return (
                <div>
                  <div className='form-content'>
                    <div className='row-input'>
                      <div className='title-input'>{t(`${GUILD_MESSAGE}.horsesInGuild`)}</div>
                      <div className='input-box'>
                        <Form.Item<FormField>
                          name='horsesInGuild'
                        >
                          <InputCustomV2
                            value={values.horsesInGuild}
                            onChange={(value) => handleChangeHorse(value, 'horsesInGuild')}
                            onKeyDown={_handleKeyDown}
                            onPaste={_handlePaste}
                            disabled={!isEdit}
                            type='text'
                            width={200}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='row-input'>
                      <div className='title-input'>{t(`${GUILD_MESSAGE}.totalRacesJoined`)}</div>
                      <div className='input-box'>
                        <Form.Item<FormField>
                          name='totalRacesJoined'
                        >
                          <InputCustomV2
                            value={values.totalRacesJoined}
                            onChange={(value) => handleChangeHorse(value, 'totalRacesJoined')}
                            onKeyDown={_handleKeyDown}
                            disabled={!isEdit}
                            type='text'
                            width={200}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {isShowAction && (
                    <Form.Item className='button-edit'>
                      {!isEdit ? (
                        <Button buttonName='Edit' onClickButton={_handleEdit} width={147} />
                      ) : (
                        <Button isLoading={loadingUpdate} buttonName='Save' onClickButton={form.submit} width={147} />
                      )}
                    </Form.Item>
                  )}
                </div>
              )
            }}
          </Form>
        </>
      )}
    </JoinRequirementStyled>
  )
}

export default JoinRequirement
